import { onMounted, onUnmounted, ref } from 'vue';
import EventBus from '../../scripts/lib/EventBus.js';

const templateElement = document.getElementById('certified-columns-template');
export default {
  template: templateElement ? templateElement.innerHTML : '',

  setup() {
    const drawer = ref(null);

    onMounted(() => {
      EventBus.on('ents:vue:certified-columns:drawer:open', openCertifiedDrawer);
    });

    onUnmounted(() => {
      EventBus.off('ents:vue:certified-columns:drawer:open', openCertifiedDrawer);
    });

    const openCertifiedDrawer = async () => {
      await import('../drawer/drawer');
      drawer.value.show();
    };

    return {
      drawer,
    };
  },
};
